import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import './videoIframe.html';
import './videoIframe.scss';

components.preload('fancybox-iframe-new');

export interface WCCFancyboxVideoIframeVMConfig {
    src: SubscribableOrNullableValue<string>
    thumbnail: SubscribableOrNullableValue<string>
}

@injectable()
export default class WCCFancyboxVideoIframeVM {
    thumbnailIsLoaded = ko.observable(false);

    src: Subscribable<string | undefined>
    thumbnail: Subscribable<string | undefined>

    isReady: Subscribable<boolean>
    hasThumbnail: Subscribable<boolean>
    thumbnailIsReady: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: WCCFancyboxVideoIframeVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.src = ko.flattenComputed(config.src);
        this.thumbnail = ko.flattenComputed(config.thumbnail);
        this.hasThumbnail = ko.pureComputed(() => this.thumbnail() != undefined);
        this.thumbnailIsReady = ko.pureComputed(() => this.hasThumbnail() && this.thumbnailIsLoaded());

        this.isReady = ko.pureComputed(() => this.src() != undefined);

        ko.applyBindingsToNode(info.element, {
            'visible': this.isReady,

            'css': {
                'fancybox-video-iframe': true
            }
        });
    }
}